module.exports = __webpack_public_path__ + "static/pic011-207d203e570820b1971a76309e743932.jpg";